import { React, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLock,
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { forgetPassword } from "../../services/authFn";
import AppLoader from "../loader/loader";

const Otpverification = () => {
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const { state } = useLocation();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);

  const email = state?.email || "";
  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  // Handle Remember Me checkbox change
  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };

  // Handle Forgot Password click
  const handleForgotPassword = () => {
    alert("Redirecting to password reset page...");
    // You could redirect to a password reset page or show a modal here
  };
  //   const navigate = useNavigate();

  // Handle OTP input change
  const handleOtpChange = (e, index) => {
    const newOtp = [...otp];
    newOtp[index] = e.target.value;
    setOtp(newOtp);

    // Move focus to the next field if the current field is filled
    if (e.target.value && index < otp.length - 1) {
      const nextInput = document.getElementById(`otp - ${index + 1}`);
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const handleSubmit = async () => {
    const otpCode = otp.join("");
    if (otpCode.length !== 4) {
      return showAlert("error", "Please enter a valid 4-digit OTP.");
    }
    if (!newPassword)
      return showAlert("Error", "New password is required", "error");
    if (!confirmPassword)
      return showAlert("Error", "Confirm password is required", "error");
    if (newPassword !== confirmPassword)
      return showAlert(
        "Error",
        "Passwords and confirm password do not match",
        "error"
      );

    const payload = {
      email: state.email,
      purpose: "Forget Password",
      role: "User",
      password: newPassword,
      otp: otpCode,
    };
    try {
      setIsLoading(true);
      const response = await forgetPassword(payload);
      if (response.data.status === "success") {
        showAlert(
          "Success",
          response?.data.message || "Registration failed.",
          "success"
        );
        navigate("/signin");
      } else {
        showAlert(
          "Error",
          response?.data.message || "Registration failed.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      showAlert(
        "Error",
        error?.response?.data?.message || error.message,
        "error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="Confirmation-section">
        <div className="Confirmation-hero">
          <div className="container Confirmation-con">
            <div className="Confirmation-box">
              <h1 className="Confirmation-pg">Confirmation</h1>
              <p>Please check your registered email for the Otp</p>
              <div className="Confirmation-input">
                <div className="Confirmation-field-container">
                  {otp?.map((digit, index) => (
                    <input
                      key={index}
                      type="text"
                      id={`otp - ${index}`}
                      value={digit}
                      onChange={(e) => handleOtpChange(e, index)}
                      maxLength="1"
                      autoFocus={index === 0}
                      placeholder="-"
                    />
                  ))}
                </div>
              </div>
              {/* Email Input */}
              {/* Email Input */}
              <div className="input-group">
                <div className="input-container">
                  <label htmlFor="email" className="input-label">
                    <FontAwesomeIcon icon={faEye} className="input-icon" />
                    Password
                  </label>
                  <input
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    type="password"
                    id="email"
                    placeholder="xxxxxxxx"
                    className="input-field"
                  />
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="input-group">
                  <div className="input-container">
                    <label htmlFor="email" className="input-label">
                      <FontAwesomeIcon icon={faEye} className="input-icon" />
                      Confirm Password
                    </label>
                    <input
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      type="password"
                      id="password2"
                      placeholder="xxxxxxxx"
                      className="input-field"
                    />
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="col-lg-12 col-md-12 col-sm-12">
                <button className="btn-1" onClick={handleSubmit}>
                  Confirm
                </button>
              </div>

              {/* Register Link */}
              {/* <div className="text-center mt-3">
                <p className="register-link">
                   <a href="/signup">Back to login</a>
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Otpverification;
